/* Lights Online – infinite scroll for collection pages (8 Oct 2026).
   Loads the next page of products when the shopper nears the end of the grid.
   The "Load more products" link stays as a crawlable fallback. Works with filters/sorting:
   facets.js re-renders the grid, which creates a fresh <lo-infinite-scroll>. */
if (!customElements.get('lo-infinite-scroll')) {
  customElements.define('lo-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      this.loading = false;
      this.more = this.querySelector('.lo-inf__more');
      if (this.more) this.more.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
      if (!this.dataset.next || !this.grid) { this.classList.add('is-done'); return; }
      if ('IntersectionObserver' in window) {
        this.classList.add('is-auto');
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) this.load();
        }, { rootMargin: '0px 0px 900px 0px' });
        this.io.observe(this);
      }
    }

    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    async load() {
      const next = this.dataset.next;
      if (this.loading || !next) return;
      this.loading = true;
      this.classList.add('is-loading');
      try {
        const url = new URL(next, window.location.origin);
        const sectionId = this.dataset.section || this.grid.dataset.id;
        if (sectionId) url.searchParams.set('section_id', sectionId);
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error(String(res.status));
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const frag = document.createDocumentFragment();
        doc.querySelectorAll('#product-grid > li').forEach((li) => {
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.removeAttribute('data-cascade');
          frag.appendChild(document.adoptNode(li));
        });
        this.grid.appendChild(frag);
        const nextEl = doc.querySelector('lo-infinite-scroll');
        this.dataset.next = nextEl && nextEl.dataset.next ? nextEl.dataset.next : '';
        const shown = this.grid.children.length;
        const total = parseInt(this.dataset.total, 10) || shown;
        const count = this.querySelector('.lo-inf__shown');
        if (count) count.textContent = Math.min(shown, total);
        const bar = this.querySelector('.lo-inf__bar span');
        if (bar) bar.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
        if (this.more && this.dataset.next) this.more.href = this.dataset.next;
        if (!this.dataset.next) {
          this.classList.add('is-done');
          if (this.io) this.io.disconnect();
        }
      } catch (err) {
        // Fall back to the visible "Load more products" button
        this.classList.remove('is-auto');
        this.classList.add('is-error');
        if (this.io) this.io.disconnect();
      }
      this.loading = false;
      this.classList.remove('is-loading');
      // If the end of the grid is still on screen, keep loading
      if (this.dataset.next && this.io) { this.io.unobserve(this); this.io.observe(this); }
    }
  });
}
